import React, {useContext} from "react";
import {Order} from "../../../app/models/order";
import moment from "moment";
import {Store} from "../../../app/stores/store-root";
import logo from "./logo.jpeg";

type BankReceiptInvoiceViewProps = {
    order: Order;
};
const BankReceiptInvoiceView = ({
                                    order,
                                }: BankReceiptInvoiceViewProps) => {
    const store = useContext(Store);
    return (
        <div className="bg-white overflow-hidden shadow rounded-lg">
            <div className="px-4 py-5 sm:p-6 border-2 border-gray-300 border-solid">
                <div>
                    <div><img className="inline-block h-10 w-10 rounded-full" src={logo}/></div>
                </div>
                <div className="max-w-full w-full flex justify-center text-gray-900 text-2xl font-bold">
                    <div> Bank Order</div>

                </div>
                <div className={"grid grid-cols-3 gap-1 mt-8"}>
                    <div className="text-gray-600 font-semibold-bold">Reference</div>
                    <div className="text-gray-600 font-semibold-bold">Pay currency</div>
                    <div className="text-gray-600 font-semibold-bold">Pay amount</div>
                    <div
                        className="border-2 font-semibold border-gray-900 py-1 solid border-opacity-50 rounded-lg  ">
                        {order.Reference}
                    </div>
                    <div
                        className="border-2 font-black border-gray-900 text-lg py-1 solid border-opacity-50  rounded-lg">
                        {order.ReceivingCurrencyCode}
                    </div>
                    <div
                        className="border-2 font-black border-gray-900 text-lg py-1 solid border-opacity-50  rounded-lg ">
                        {order?.ReceivingAmount!!.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                    <div className="col-span-3"/>
                    <div className="text-gray-600 font-semibold">Benficiary</div>
                    <div className="text-gray-600 font-semibold">Remitter</div>
                    <div className="text-gray-600 font-semibold">Source Amount</div>
                    <div className=" font-semibold border-gray-900 py-1 solid border-opacity-50   rounded-lg ">
                        <p className="capitalize ...">{order.BeneficiaryName}</p>

                    </div>
                    <div className="font-semibold border-gray-900 py-1 solid border-opacity-50  rounded-lg ">
                        <p className="capitalize ...">{order.RemitterName}</p>


                    </div>
                    <div className="font-semibold border-gray-900 py-1 solid border-opacity-50  rounded-lg ">
                        {`${order.SendingCurrencyCode} ${order.SendingAmount} `}
                    </div>
                </div>
                <div className={"grid grid-cols-3 gap-1 mt-8"}>
                    <div className="text-gray-600 font-semibold">Receiver Telephone</div>
                    <div className="text-gray-600 font-semibold">Bank</div>
                    <div className="text-gray-600 font-semibold">Bank Branch</div>
                    <div className="font-semibold border-gray-900 py-1 solid border-opacity-50  rounded-lg ">
                        {order.BeneficiaryPhone}
                    </div>
                    <div className="font-semibold border-gray-900 py-1 solid border-opacity-50  rounded-lg ">
                        {order.DeliveryBank}
                    </div>
                    <div className="font-semibold border-gray-900 py-1 solid border-opacity-50  rounded-lg ">
                        {order.DeliveryBankBranch}
                    </div>

                </div>
                <div className={"grid grid-cols-3 gap-1 mt-8"}>
                    <div className="col-span-3 mt-2"/>
                    <div className="text-gray-600 font-semibold">Bank Account</div>
                    <div className="text-gray-600 font-semibold">Order Date</div>
                    <div className="text-gray-600 font-semibold">Exchange Rate</div>
                    <div className="font-semibold border-gray-900  py-1 solid border-opacity-50  rounded-lg">
                        {order.DeliveryBankAccount}
                    </div>
                    <div className=" font-semibold border-gray-900  py-1 solid border-opacity-50  rounded-lg ">
                        {moment(order.CreatedAt).format("MMMM Do YYYY, h:mm:ss a")}
                    </div>
                    <div className="font-semibold border-gray-900  py-1 solid border-opacity-50  rounded-lg ">
                        {parseFloat(order.ExchangeRate).toFixed(4)}
                    </div>
                </div>
                <div className={"grid grid-cols-3 gap-1 mt-8"}>
                    <div className="col-span-3 mt-2"/>
                    <div className="text-gray-600 font-semibold">Bank teller</div>
                    <div className="text-gray-600 font-semibold">Paid Date</div>
                    <div className="text-gray-600 font-semibold"></div>
                    <div className="font-semibold border-gray-900  py-1 solid border-opacity-50  rounded-lg">
                        {`${store.Users.Name.charAt(0).toUpperCase() + store.Users.Name.slice(1)} ${store.Users.FamilyName.charAt(0).toUpperCase() + store.Users.FamilyName.slice(1)} (${store.Users.UserName})`}
                    </div>
                    <div className="font-semibold border-gray-900  py-1 solid border-opacity-50  rounded-lg ">
                        {moment(order.PaidAt).format("MMMM Do YYYY, h:mm:ss a")}
                    </div>
                </div>

                <div className={'grid grid-cols-6 gap-x-8 my-12'}>
                    {/*<div className={'font-bold'}>Guarantor Signature___________________</div>*/}
                    {/*<div className={'border-b-2 border-gray-900'}></div>*/}
                    {/*<div className={'font-bold'}>Cashier Signature____________________</div>*/}
                    {/*<div className={'border-b-2 border-gray-900'}></div>*/}
                </div>
            </div>


        </div>
    );
};

export default BankReceiptInvoiceView;
